import { ProfessionalServicesSessionProjectsState } from '@pages/professional-services/store/state/professional-services-session-projects.state';
import { ProfessionalServicesSessionsCountState } from '@pages/professional-services/store/state/professional-services-sessions-count.state';
import { ProfessionalServicesRecentSessionsState } from '@pages/professional-services/store/state/professional-services-recent-sessions.state';
import { ProfessionalServicesUpcomingSessionsState } from '@pages/professional-services/store/state/professional-services-upcoming-sessions.state';
import { ProfessionalServicesSessionDetailsState } from '@pages/professional-services/store/state/professional-services-session-details.state';
import { ProfessionalServicesHasAnyProjectsState } from '@pages/professional-services/store/state/professional-services-has-any-projects.state';

export const professionalServicesState = [
  ProfessionalServicesSessionProjectsState,
  ProfessionalServicesSessionsCountState,
  ProfessionalServicesRecentSessionsState,
  ProfessionalServicesUpcomingSessionsState,
  ProfessionalServicesSessionDetailsState,
  ProfessionalServicesSessionDetailsState,
  ProfessionalServicesHasAnyProjectsState,
];
